import React, { useEffect, useState,useRef  } from "react";
import { Link,useNavigate  } from "react-router-dom"; 
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import { v4 as uuidv4 } from "uuid";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';
import { toast } from "react-toastify";
import "../styles/global.css";

 

const BrandList = () => { 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);  

    const [brands, setBrands] = useState([]);

    
const fetchBrandData = () => {
      let isCalled = false;

      if (!isCalled) {
        fetch(`${API_BASE_URL}api/brandData`)
          .then(res => res.json())
          .then(data => {
            const list = Array.isArray(data) ? data : data.data;
            setBrands(list || []);
          })
          .catch(err => console.log(err));
      }

      return () => {
        isCalled = true;
      };
  };

   useEffect(() => {
 fetchBrandData();
}, []);


let deviceId = localStorage.getItem("device_id");
if (!deviceId) {
  deviceId = uuidv4();  // generates unique universal ID
  localStorage.setItem("device_id", deviceId);
}
 
  return (
    <>
       <Header/>
   
    <br/>
   <section className="category section-padding pt-0">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2>Brands</h2>
        </div>
        <div className="col-12"> 
          <div className="grid-6">
              {brands.map(brand => ( 
                  <div className="item">
                    <Link to={`/category/${brand.slug}`}>
                      <div className="product-thumb">
                        <img
                          src={brand.image ? `${API_BASE_URL}public/brand/${brand.image}` : `${API_BASE_URL}public/noimage.jpg`}
                          alt={brand.name}
                        />
                      </div>
                      <h3>{brand.name.replace(/\b\w/g, c => c.toUpperCase())}</h3>
                    </Link>
                  </div> 
              ))} 
            </div>
        </div>
      </div>
    </div>
  </section> 
  
       <Footer/>
    </>
  );
};

export default BrandList;
